
<Modal
  title="Verify ownership"
  actionTitle="Confirm"
  {isLoading}
  on:close={() => ($uiState.activeModal = undefined)}
  on:action={() => apply()}>
  <p class="block">Verify ownership of this charity by the user.</p>

  {#if errorMessage}
    <div class="block notification is-danger is-light">{errorMessage}</div>
  {/if}
</Modal>

<script lang="ts">
  export let id :string;

  import { logging } from '../../../../../lib/logging';
  import { uiState } from "../../../../../lib/uiState";
  import Modal from "../../../../_components/Modal.svelte";

  let errorMessage :string;
  let isLoading :boolean;

  async function apply() {
    isLoading = true;

    const firebase = window.firebase;

    await firebase
      .firestore()
      .collection("charities_v2")
      .doc(id)
      .update({
        isOwnershipVerified: true
      })
      .then(() => {
        $uiState.activeModal = undefined;
      })
      .catch((err) => {
        logging.report(err.toString());
        errorMessage = err;
      })
      .finally(() => (isLoading = false));
  }
</script>
